module.exports = __webpack_public_path__ + "img/hu.f8ec353b.svg";